import api from '../lib/api';

const feedbackService = {
    // Submit feedback
    submitFeedback: async (feedbackData) => {
        try {
            const response = await api.post('/feedback', feedbackData);
            return response.data;
        } catch (error) {
            console.error('Error submitting feedback:', error);
            throw error;
        }
    },

    // Get user's feedback history (if authenticated)
    getMyFeedback: async () => {
        try {
            const response = await api.get('/feedback/my');
            return response.data;
        } catch (error) {
            console.error('Error fetching feedback:', error);
            throw error;
        }
    },

    // Admin: Get all feedbacks
    adminGetFeedbacks: async (params = {}) => {
        try {
            const response = await api.get('/admin/feedback', { params });
            return response.data;
        } catch (error) {
            console.error('Error fetching feedbacks:', error);
            throw error;
        }
    },

    // Admin: Get feedback statistics
    adminGetStatistics: async () => {
        try {
            const response = await api.get('/admin/feedback/statistics');
            return response.data;
        } catch (error) {
            console.error('Error fetching feedback statistics:', error);
            throw error;
        }
    }
};

export default feedbackService;

